import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

const flyLegacyUrl = `${environment.flyLegacyUrl}`;

@Injectable()
export class LinksService {
  getFlyLegacyDeviceDetailsUrl(deviceId: number): string {
    return `${flyLegacyUrl}/devices/details/${deviceId}`;
  }

  getFlyLegacyAircraftDetailsUrl(aircraftId: string): string {
    return `${flyLegacyUrl}/devices/aircraft/${aircraftId}`;
  }

  getFlyLegacyGarminPilotSupscriptionsUrl(): string {
    return `${flyLegacyUrl}/garmin-pilot/subscriptions/`;
  }
}
